import { render } from "./AgeRestrictedBanner.vue?vue&type=template&id=23351f59&scoped=true"
import script from "./AgeRestrictedBanner.vue?vue&type=script&lang=js"
export * from "./AgeRestrictedBanner.vue?vue&type=script&lang=js"

import "./AgeRestrictedBanner.vue?vue&type=style&index=0&id=23351f59&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23351f59"]])

export default __exports__